import React, { useState } from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { TermsModal, PrivacyModal } from './LegalModals';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qtRkR6UFYwHcZHUZTWVph1/Titulo.png';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
// TikTok icon component since lucide doesn't have it
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-49">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-50" />
    </svg>;
}
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const socialLinks = [{
    name: 'Facebook',
    icon: Facebook,
    href: 'https://www.facebook.com/Ingenieria.Jazuga'
  }, {
    name: 'Instagram',
    icon: Instagram,
    href: 'https://www.instagram.com/jazuga_/'
  }, {
    name: 'TikTok',
    icon: TikTokIcon,
    href: 'https://www.tiktok.com/@certificacionesgaslp'
  }];
  return <>
      <footer className="bg-slate-900 text-slate-400 relative overflow-hidden" data-id="element-51">
        {/* Background Logo */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-52">
          <img src={LOGO_URL} alt="" className="w-[500px] h-auto opacity-[0.03] brightness-0 invert" data-id="element-53" />
        </div>

        {/* Main Footer */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-54">
          <div className="grid md:grid-cols-4 gap-12" data-id="element-55">
            {/* Brand Column */}
            <div className="md:col-span-2" data-id="element-56">
              <img src={LOGO_URL} alt="Jazugas - Ingeniería Electromecánica" className="h-24 w-auto mb-6 brightness-0 invert" data-id="element-57" />
              <p className="text-slate-400 max-w-md leading-relaxed mb-6" data-id="element-58">
                Somos expertos en certificaciones de gas LP para negocios en
                Costa Rica. Nuestra plataforma digital te permite obtener tu
                certificación en tiempo récord, cumpliendo todos los requisitos
                del Ministerio de Salud.
              </p>
              <div className="flex items-center gap-2 text-[#f59e0b] font-semibold" data-id="element-59">
                <span data-id="element-60">🔥</span>
                <span data-id="element-61">Certificación LP Express</span>
              </div>
            </div>

            {/* Links Column */}
            <div data-id="element-62">
              <h4 className="text-white font-bold mb-4" data-id="element-63">Enlaces</h4>
              <ul className="space-y-3" data-id="element-64">
                <li data-id="element-65">
                  <a href="#beneficios" className="hover:text-white transition-colors" data-id="element-66">
                    Beneficios
                  </a>
                </li>
                <li data-id="element-67">
                  <a href="#proceso" className="hover:text-white transition-colors" data-id="element-68">
                    Proceso
                  </a>
                </li>
                <li data-id="element-69">
                  <a href="#testimonios" className="hover:text-white transition-colors" data-id="element-70">
                    Testimonios
                  </a>
                </li>
                <li data-id="element-71">
                  <a href="#faq" className="hover:text-white transition-colors" data-id="element-72">
                    Preguntas Frecuentes
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Column */}
            <div data-id="element-73">
              <h4 className="text-white font-bold mb-4" data-id="element-74">Contacto</h4>
              <ul className="space-y-3" data-id="element-75">
                <li data-id="element-76">
                  <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-77">
                    <span data-id="element-78">📱</span>
                    <span data-id="element-79">+506 8992-5929</span>
                  </a>
                </li>
                <li data-id="element-80">
                  <a href="mailto:jazuga74@gmail.com" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-81">
                    <span data-id="element-82">✉️</span>
                    <span data-id="element-83">jazuga74@gmail.com</span>
                  </a>
                </li>
                <li className="flex items-center gap-2" data-id="element-84">
                  <span data-id="element-85">📍</span>
                  <span data-id="element-86">Costa Rica</span>
                </li>
              </ul>

              {/* Social Links */}
              <div className="mt-6" data-id="element-87">
                <h4 className="text-white font-bold mb-4" data-id="element-88">Síguenos</h4>
                <div className="flex items-center gap-4" data-id="element-89">
                  {socialLinks.map(social => <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-[#f59e0b] rounded-full flex items-center justify-center transition-colors" aria-label={social.name} data-id="element-90">
                      <social.icon className="w-5 h-5" data-id="element-91" />
                    </a>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="relative border-t border-slate-800" data-id="element-92">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-93">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-94">
              <div className="text-sm" data-id="element-95">
                © {new Date().getFullYear()} Jazugas Ingeniería
                Electromecánica. Todos los derechos reservados.
              </div>
              <div className="flex gap-6 text-sm" data-id="element-96">
                <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors" data-id="element-97">
                  Términos y Condiciones
                </button>
                <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-white transition-colors" data-id="element-98">
                  Política de Privacidad
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-99" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-100" />
    </>;
}